import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';
import { getDeployTarget } from '../config/environment';

export async function fetchReferralPreview(code) {
  const fn = httpsCallable(functions, 'getReferralPreview');
  const result = await fn({ code: String(code || '').trim() });
  return result?.data || { valid: false };
}

export async function fetchMyActiveReferral() {
  const fn = httpsCallable(functions, 'getMyActiveReferral');
  const result = await fn({ deployTarget: getDeployTarget() });
  const data = result?.data || { active: false, referrals: [] };
  if (!Array.isArray(data.referrals)) {
    data.referrals = data.active && data.code
      ? [{
          code: data.code,
          holdCents: data.holdCents,
          status: data.status,
          createdAt: data.createdAt,
        }]
      : [];
  }
  return data;
}

export async function createReferralCode() {
  const fn = httpsCallable(functions, 'createReferralCode');
  const result = await fn({ deployTarget: getDeployTarget() });
  return result?.data || {};
}

export async function cancelReferralCode(code) {
  const fn = httpsCallable(functions, 'cancelReferralCode');
  const result = await fn({ code, deployTarget: getDeployTarget() });
  return result?.data || {};
}
